import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const ADMIN_KEY = "mixology_admin_pin";
// Tab-scoped storage: PIN clears when browser tab closes, reducing exposure
// on shared devices at the venue. Backend re-validates on every request.
const adminStore = () => (typeof window === "undefined" ? null : window.sessionStorage);

export const adminPin = () => adminStore()?.getItem(ADMIN_KEY) || "";
export const setAdminPin = (pin) => adminStore()?.setItem(ADMIN_KEY, pin);
export const clearAdminPin = () => adminStore()?.removeItem(ADMIN_KEY);
export const isAdmin = () => !!adminPin();

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
    const pin = adminPin();
    if (pin) config.headers["X-Admin-Pin"] = pin;
    return config;
});

export const Admin = {
    login: (pin) => api.post("/admin/login", { pin }).then(r => r.data),
};

export const PublicTables = {
    list: () => api.get("/public/tables").then(r => r.data),
};

export const Players = {
    list: () => api.get("/players").then(r => r.data),
    create: (data) => api.post("/players", data).then(r => r.data),
    remove: (id) => api.delete(`/players/${id}`).then(r => r.data),
};

export const Tables = {
    list: (status) => api.get("/tables", { params: status ? { status } : {} }).then(r => r.data),
    create: (data) => api.post("/tables", data).then(r => r.data),
    get: (id) => api.get(`/tables/${id}`).then(r => r.data),
    close: (id) => api.post(`/tables/${id}/close`).then(r => r.data),
    remove: (id) => api.delete(`/tables/${id}`).then(r => r.data),
    seat: (id, data) => api.post(`/tables/${id}/seat`, data).then(r => r.data),
    unseat: (id, seatNumber) => api.post(`/tables/${id}/unseat/${seatNumber}`).then(r => r.data),
    addBuyin: (id, data) => api.post(`/tables/${id}/buyin`, data).then(r => r.data),
    addCashout: (id, data) => api.post(`/tables/${id}/cashout`, data).then(r => r.data),
    addHand: (id, data) => api.post(`/tables/${id}/hand`, data).then(r => r.data),
    getWaitlist: (id) => api.get(`/tables/${id}/waitlist`).then(r => r.data),
    addToWaitlist: (id, data) => api.post(`/tables/${id}/waitlist`, data).then(r => r.data),
};

export const Waitlist = {
    notify: (entryId) => api.post(`/waitlist/${entryId}/notify`).then(r => r.data),
    remove: (entryId) => api.delete(`/waitlist/${entryId}`).then(r => r.data),
};

export const Checkin = {
    submit: (data) => api.post("/checkin", data).then(r => r.data),
};

export const Venue = {
    payment: () => api.get("/venue/payment").then(r => r.data),
};

export const Dashboard = {
    summary: () => api.get("/dashboard/summary").then(r => r.data),
};
